export const HOME = "/";
export const DASHBOARD = "/dashboard";
export const RESULT = "/result";
export const PAGE_NOT_FOUND = "*";